module.exports = __webpack_public_path__ + "static/media/2.a2ee41d.wav";


//////////////////
// WEBPACK FOOTER
// ./src/assets/audio/majors/2.wav
// module id = LD69
// module chunks = 0